import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getCellStyles } from './hooks/getCellStyles'

export const Table = styled.table`
  width: 100%;
`

export const HeadRow = styled.tr`
  background-color: ${Color.Grey100};
`

export const HeadCell = styled.th`
  min-width: 102px;
  ${getCellStyles()}

  &:first-child {
    width: 100%;
  }
`

export const BodyCell = styled.td`
  ${getCellStyles()}

  &:first-child {
    display: flex;
    gap: ${Spacing.S16};
  }
`
